import React from "react";
import { logoutUser } from "../utils/helper";
import { useHistory } from "react-router-dom";
import { Link } from "react-router-dom/cjs/react-router-dom.min";


function Nav() {
    // const TOKEN = localStorage.getItem("kloka:token:data");
    const history = useHistory();

    const handleLogout = async () => {
        await logoutUser().then((res) => {
            
            console.log(res.data)
            
            localStorage.removeItem("kloka:token:data");
            localStorage.removeItem("kloka:type");
            localStorage.removeItem("kloka:role");
            localStorage.removeItem("kloka:categories");
            
            history.push("/");

            setTimeout(() => {
                window.location.reload();
            }, 200);

          })
          .catch((err) => {

            console.log(err.response)

            localStorage.removeItem("kloka:token:data");
            localStorage.removeItem("kloka:type");
            localStorage.removeItem("kloka:role");
            localStorage.removeItem("kloka:categories");
            
            history.push("/");

            setTimeout(() => {
              window.location.reload();
            }, 200);
        });
    };

    return (        
        <header className="dash-toolbar">
            <div className="menu-toggle"><i className="fa fa-bars"></i></div>
            <div className="searchbox-toggle"><i className="fa fa-search"></i></div>
            <form className="searchbox">
                <button type="button" className="searchbox-toggle"> <i className="fa fa-arrow-left"></i> </button>
                <button type="button" className="searchbox-submit"> <i className="fa fa-search"></i> </button>
                <input type="text" className="searchbox-input" placeholder="type to search" />
            </form>
            <div className="tools">
                <Link to="/password" className="tools-item">
                    <i className="fa fa-cog"></i>
                </Link>
                <div className="dropdown tools-item">
                    <button id="dropdownMenu1" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" style={{border: 'transparent'}}>
                        <i className="fa fa-user"></i>
                    </button>
                    <div className="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenu1">
                        <Link className="dropdown-item" to="/profile">Profile</Link>
                        <button className="dropdown-item" onClick={handleLogout} >Logout</button>
                    </div>
                </div>
            </div>
        </header>

    );
}

export default Nav;



